/**
 * Password Setup API functions for Virtual Assistant members
 */
import api from './client';

export interface RequestPasswordSetupRequest {
  email: string;
}

export interface SetInitialPasswordRequest {
  token: string;
  password: string;
  confirm_password: string;
}

export interface MessageResponse {
  message: string;
}

/**
 * Request a password setup email for VA members
 */
export const requestPasswordSetup = async (email: string): Promise<MessageResponse> => {
  const response = await api.post<MessageResponse>('/api/auth/request-password-setup', { email });
  return response.data;
};

/**
 * Set initial password using token from email
 */
export const setInitialPassword = async (
  token: string,
  password: string,
  confirmPassword: string
): Promise<MessageResponse> => {
  const response = await api.post<MessageResponse>('/api/auth/set-initial-password', {
    token,
    password,
    confirm_password: confirmPassword,
  });
  return response.data;
};
